"use strict";

if (!customElements.get("product-card-variant-picker")) {
	customElements.define(
		"product-card-variant-picker",
			class ProductCardVariantPicker extends HTMLElement {
				connectedCallback() {
					this.addEventListener("click", this.handleClick);
					this.addEventListener("pointerdown", this.handlePointerDown);
					this.addEventListener("pointermove", this.handlePointerMove);
					this.addEventListener("pointerup", this.handlePointerUp);
					this.addEventListener("pointercancel", this.handlePointerUp);
				}

				disconnectedCallback() {
					this.removeEventListener("click", this.handleClick);
					this.removeEventListener("pointerdown", this.handlePointerDown);
					this.removeEventListener("pointermove", this.handlePointerMove);
					this.removeEventListener("pointerup", this.handlePointerUp);
					this.removeEventListener("pointercancel", this.handlePointerUp);
				}

				handlePointerDown(event) {
					if (event.pointerType !== "mouse" || event.button !== 0) return;

					this.dragPointerId = event.pointerId;
					this.dragStartX = event.clientX;
					this.dragStartScrollLeft = this.scrollLeft;
					this.isDragging = false;
				}

				handlePointerMove(event) {
					if (event.pointerId !== this.dragPointerId) return;

					const distance = event.clientX - this.dragStartX;
					if (Math.abs(distance) > 4) {
						if (!this.hasPointerCapture(event.pointerId)) {
							this.setPointerCapture(event.pointerId);
						}
						this.hideStockPopup();
						this.isDragging = true;
						this.classList.add("is-dragging");
					}

					if (!this.isDragging) return;

					event.preventDefault();
					this.scrollLeft = this.dragStartScrollLeft - distance;
				}

				handlePointerUp(event) {
					if (event.pointerId !== this.dragPointerId) return;

					if (this.hasPointerCapture(event.pointerId)) {
						this.releasePointerCapture(event.pointerId);
					}
					this.classList.remove("is-dragging");

					if (this.isDragging) {
						this.suppressClick = true;
						requestAnimationFrame(() => {
							this.suppressClick = false;
						});
					}

					this.isDragging = false;
					this.dragPointerId = null;
				}

				hideStockPopup() {
					const popup = document.querySelector(".product-variant-stock-popup");
					if (!popup) return;

					popup.classList.remove("is-visible");
					popup.hidden = true;
					window.clearTimeout(window.productVariantStockPopupTimer);
				}

				showStockPopup(button) {
					let popup = document.querySelector(".product-variant-stock-popup");

					if (!popup) {
						popup = document.createElement("div");
						popup.className = "product-variant-stock-popup";
						popup.setAttribute("role", "status");
						popup.setAttribute("aria-live", "polite");
						document.body.appendChild(popup);
					}

					window.clearTimeout(window.productVariantStockPopupTimer);
					popup.textContent = button.dataset.outOfStockLabel || "Out of stock";
					popup.hidden = false;
					popup.classList.remove("is-below");

					const buttonRect = button.getBoundingClientRect();
					const popupWidth = popup.offsetWidth;
					const popupHeight = popup.offsetHeight;
					const viewportGap = 8;
					const minimumLeft = viewportGap + popupWidth / 2;
					const maximumLeft = window.innerWidth - viewportGap - popupWidth / 2;
					const buttonCenter = buttonRect.left + buttonRect.width / 2;
					const popupLeft = Math.min(Math.max(buttonCenter, minimumLeft), maximumLeft);
					const showBelow = buttonRect.top < popupHeight + viewportGap;

					popup.classList.toggle("is-below", showBelow);
					popup.style.left = `${popupLeft}px`;
					popup.style.top = `${showBelow ? buttonRect.bottom : buttonRect.top}px`;

					requestAnimationFrame(() => popup.classList.add("is-visible"));

					window.productVariantStockPopupTimer = window.setTimeout(() => {
						this.hideStockPopup();
					}, 2200);
				}

					handleClick(event) {
						const button = event.target.closest(".product-variant-tag");

						// A tag click only selects the variant and must not trigger
						// any delegated product-card navigation.
						event.preventDefault();
						event.stopPropagation();

						if (this.suppressClick || !button) {
							return;
						}

						if (button.hasAttribute("data-unavailable")) {
							this.showStockPopup(button);
							return;
						}

						this.hideStockPopup();

						if (button.disabled || button.classList.contains("selected")) return;

				const card = button.closest(".product-card");
				const variantsElement = card && card.querySelector("[data-product-variants]");
				const variantInput = card && card.querySelector('input[name="id"]');
				if (!card || !variantsElement || !variantInput) return;

				const variants = JSON.parse(variantsElement.textContent);
				const variantId = Number(button.dataset.variantId);
				const variant = variants.find((item) => item.id === variantId);
				if (!variant) return;

				this.querySelectorAll(".product-variant-tag").forEach((item) => {
					const isSelected = item === button;
					item.classList.toggle("selected", isSelected);
					item.setAttribute("aria-pressed", isSelected ? "true" : "false");
				});

				variantInput.value = variant.id;
				variantInput.dispatchEvent(new Event("change", { bubbles: true }));

				const price = card.querySelector(".product-price");
				if (price && typeof window.btyPriceHtml === "function") {
					const compareAtPrice =
						variant.compare_at_price && variant.compare_at_price > variant.price
							? variant.compare_at_price
							: false;

						price.classList.toggle("price--on-sale", Boolean(compareAtPrice));
						price.classList.toggle("price--sold-out", !variant.available);
						price.innerHTML = window.btyPriceHtml(
							variant.price,
							compareAtPrice,
							variant.unit_price,
							variant.unit_price_measurement
						);

						if (compareAtPrice) {
							const saleContainer = document.createElement("div");
							saleContainer.className = "price__sale";

							price
								.querySelectorAll(
									":scope > .price, :scope > .regular-price, :scope > .product-sale-label"
								)
								.forEach((element) => saleContainer.appendChild(element));

							price.prepend(saleContainer);
						}

						if (
							compareAtPrice &&
							price.hasAttribute("data-card-price") &&
							typeof window.btyFormatPrice === "function"
						) {
							const saving = compareAtPrice - variant.price;
							const saleTotal = price.querySelector(".sale-total");

							if (saleTotal) {
								const saveLabel = price.dataset.saveLabel || "Save";
								saleTotal.textContent = `${saveLabel} ${window.btyFormatPrice(saving)}`;
							}
						}
					}

				const image = card.querySelector(".product-image img");
				const imageSrc = button.dataset.imageSrc;
				if (image && imageSrc) {
					image.src = imageSrc;
					image.dataset.src = imageSrc;
					image.removeAttribute("srcset");
					image.removeAttribute("data-srcset");
				}

				const addButton = card.querySelector(".add-to-cart-button");
				if (addButton) {
					addButton.disabled = !variant.available;
					addButton.classList.toggle("disabled", !variant.available);
				}

					const variantUrl = button.dataset.variantUrl;
					const content = card.querySelector(".product-card-content");
					if (variantUrl && content) {
						content.dataset.productUrl = variantUrl;
						const contentLink = content.querySelector(":scope > a");
						if (contentLink) contentLink.href = variantUrl;
					}

				if (variantUrl) {
					card.querySelectorAll(".product-image, .product-title a").forEach((link) => {
						link.href = variantUrl;
					});
				}
			}
		}
	);
}

if (!window.productCardContentLinkInitialized) {
	window.productCardContentLinkInitialized = true;

	document.addEventListener("click", (event) => {
		const content = event.target.closest(".product-card-content");
		if (!content) return;

		if (
			event.target.closest(
				"product-card-variant-picker, a, button, input, select, textarea, label"
			)
		) {
			return;
		}

		const productUrl = content.dataset.productUrl;
		if (productUrl) window.location.assign(productUrl);
	});
}
